import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import {createFocusableRef as $3c2c983d5210446c$export$79d69eee6ae4b329} from "../utils/useDOMRef.mjs";
import {Field as $adcd096854d27620$export$a455218a85c89869} from "../label/Field.mjs";
import $3xlai$intlStringsmjs from "./intlStrings.mjs";
import "../textfield_vars.css";
import $3xlai$textfield_vars_cssmjs from "../textfield_vars_css.mjs";
import $3xlai$spectrumiconsuiAlertMedium from "@spectrum-icons/ui/AlertMedium";
import $3xlai$spectrumiconsuiCheckmarkMedium from "@spectrum-icons/ui/CheckmarkMedium";
import {mergeProps as $3xlai$mergeProps} from "react-aria/mergeProps";
import $3xlai$react, {forwardRef as $3xlai$forwardRef, useRef as $3xlai$useRef, useImperativeHandle as $3xlai$useImperativeHandle, cloneElement as $3xlai$cloneElement} from "react";
import {useFocusRing as $3xlai$useFocusRing} from "react-aria/useFocusRing";
import {useHover as $3xlai$useHover} from "react-aria/useHover";
import {useId as $3xlai$useId} from "react-aria/useId";
import {useLocalizedStringFormatter as $3xlai$useLocalizedStringFormatter} from "react-aria/useLocalizedStringFormatter";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 












const $b312f2102feb9487$export$d22444a338b6e3c2 = /*#__PURE__*/ (0, $3xlai$forwardRef)(function TextFieldBase(props, ref) {
    let { validationState: validationState = props.isInvalid ? 'invalid' : null, icon: icon, isQuiet: isQuiet = false, isDisabled: isDisabled, multiLine: multiLine, autoFocus: autoFocus, inputClassName: inputClassName, wrapperChildren: wrapperChildren, labelProps: labelProps, inputProps: inputProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps, inputRef: userInputRef, isLoading: isLoading, loadingIndicator: loadingIndicator, validationIconClassName: validationIconClassName, disableFocusRing: disableFocusRing } = props;
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $3xlai$useHover)({
        isDisabled: isDisabled
    });
    let domRef = (0, $3xlai$useRef)(null);
    let defaultInputRef = (0, $3xlai$useRef)(null);
    let inputRef = userInputRef || defaultInputRef;
    // Expose imperative interface for ref
    (0, $3xlai$useImperativeHandle)(ref, ()=>({
            ...(0, $3c2c983d5210446c$export$79d69eee6ae4b329)(domRef, inputRef),
            select () {
                if (inputRef.current) inputRef.current.select();
            },
            getInputElement () {
                return inputRef.current;
            }
        }));
    let ElementType = multiLine ? 'textarea' : 'input';
    let isInvalid = validationState === 'invalid' && !isDisabled;
    if (icon) {
        let UNSAFE_className = (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($3xlai$textfield_vars_cssmjs))), icon.props && icon.props.UNSAFE_className, 'spectrum-Textfield-icon');
        icon = /*#__PURE__*/ (0, $3xlai$cloneElement)(icon, {
            UNSAFE_className: UNSAFE_className,
            size: 'S'
        });
    }
    let stringFormatter = (0, $3xlai$useLocalizedStringFormatter)((0, ($parcel$interopDefault($3xlai$intlStringsmjs))), '@react-spectrum/textfield');
    let validId = (0, $3xlai$useId)();
    let validationIcon = isInvalid ? /*#__PURE__*/ (0, $3xlai$react).createElement((0, $3xlai$spectrumiconsuiAlertMedium), null) : /*#__PURE__*/ (0, $3xlai$react).createElement((0, $3xlai$spectrumiconsuiCheckmarkMedium), {
        id: validId,
        "aria-hidden": true,
        "aria-label": stringFormatter.format('valid')
    });
    let validation = /*#__PURE__*/ (0, $3xlai$cloneElement)(validationIcon, {
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($3xlai$textfield_vars_cssmjs))), 'spectrum-Textfield-validationIcon', validationIconClassName)
    });
    // Add validation icon IDREF to aria-describedby when validationState is valid
    let inputPropsAriaDescribedBy = inputProps['aria-describedby'];
    if (!isInvalid && validationState === 'valid' && !isLoading && !isDisabled && (!inputPropsAriaDescribedBy || !inputPropsAriaDescribedBy.includes(validId))) inputProps['aria-describedby'] = [
        inputPropsAriaDescribedBy,
        validId
    ].join(' ').trim();
    let { focusProps: focusProps, isFocusVisible: isFocusVisible } = (0, $3xlai$useFocusRing)({
        isTextInput: true,
        autoFocus: autoFocus
    });
    let textField = /*#__PURE__*/ (0, $3xlai$react).createElement("div", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($3xlai$textfield_vars_cssmjs))), 'spectrum-Textfield', {
            'spectrum-Textfield--invalid': isInvalid,
            'spectrum-Textfield--valid': validationState === 'valid' && !isDisabled,
            'spectrum-Textfield--loadable': loadingIndicator,
            'spectrum-Textfield--quiet': isQuiet,
            'spectrum-Textfield--multiline': multiLine,
            'focus-ring': !disableFocusRing && isFocusVisible
        })
    }, /*#__PURE__*/ (0, $3xlai$react).createElement(ElementType, {
        ...(0, $3xlai$mergeProps)(inputProps, hoverProps, focusProps),
        ref: inputRef,
        rows: multiLine ? 1 : undefined,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($3xlai$textfield_vars_cssmjs))), 'spectrum-Textfield-input', {
            'spectrum-Textfield-inputIcon': icon,
            'is-hovered': isHovered
        }, inputClassName)
    }), icon, validationState && !isLoading && !isDisabled ? validation : null, isLoading && loadingIndicator, wrapperChildren);
    return /*#__PURE__*/ (0, $3xlai$react).createElement((0, $adcd096854d27620$export$a455218a85c89869), {
        ...props,
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        wrapperClassName: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($3xlai$textfield_vars_cssmjs))), 'spectrum-Textfield-wrapper', {
            'spectrum-Textfield-wrapper--quiet': isQuiet
        }),
        showErrorIcon: false,
        ref: domRef
    }, textField);
});


export {$b312f2102feb9487$export$d22444a338b6e3c2 as TextFieldBase};
//# sourceMappingURL=TextFieldBase.mjs.map
